import React from 'react';
import styled from 'styled-components';
import media from 'constants/styles/media';
import layout from 'constants/styles/layout';

const SSection = styled.section`
    width: 100%;
    margin-top: ${layout.sectionSpacing};

    @media (max-width: ${media.tablet}) {
        margin-top: ${layout.sectionSpacingMobile};
    }
`;

type Props = React.HTMLAttributes<HTMLElement>;

export const Section = ({ className, children, ...props }: Props) => {
    return (
        <SSection className={className} {...props}>
            {children}
        </SSection>
    );
};
